module.exports = __webpack_public_path__ + "img/livepen-photo-m.6de18aa7.png";